export default __webpack_public_path__ + "static/media/tandem.e51f42d8.webp";